import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  display: block;
  .skeleton-box{
    height: 100px;
    width: 100%;
    border-radius: 8px;
    margin-bottom: 20px;
  }
`;

const StatesWidgetSkeleton = function StatesWidgetSkeleton() {
  return (
    <Wrapper>
      <span className="skeleton-box" />
    </Wrapper>
  );
};

export default StatesWidgetSkeleton;
